import { useEffect, useRef } from 'react';
import { useQuery, useQueryClient } from 'react-query';

import useAuth from './useAuth';

import {
  checkNuevaPublicacion,
  refreshAccountInitialData,
} from '@/services/auth0';

const CINCO_MINUTOS = 5 * 60 * 1000;

const useCheckPublicacion = (torneo: 'A' | '5') => {
  const { userInitialData, setUserInitialData } = useAuth();
  const queryClient = useQueryClient();

  const userDataRef = useRef(userInitialData);
  useEffect(() => {
    userDataRef.current = userInitialData;
  }, [userInitialData]);

  useQuery('checkNuevaPublicacion', checkNuevaPublicacion, {
    enabled: !!userInitialData,
    refetchInterval: CINCO_MINUTOS,
    refetchOnWindowFocus: false,
    onSuccess: async (pPubData) => {
      const current = userDataRef.current;
      if (!pPubData || !current) return;

      const pubData = await pPubData;
      if (pubData.estado === false) return;

      const fechaChanged =
        pubData.uvr_factual_orden !== current.uvr.uvr_factual_orden ||
        pubData.uvr_factual_olock !== current.uvr.uvr_factual_olock;

      if (torneo === '5') {
        const f5Changed =
          pubData.uvr_f5_idVersionRanking !==
          current.uvr.uvr_f5_idVersionRanking;

        if (f5Changed || fechaChanged) {
          const freshData = await refreshAccountInitialData();
          if (freshData?.estado) {
            setUserInitialData(freshData);
            queryClient.invalidateQueries('useGetCurrentTeamF5');
          }
        }
        return;
      }

      const rankingChanged =
        pubData.uvr_idVersionRanking !== current.uvr.uvr_idVersionRanking;

      if (fechaChanged || rankingChanged) {
        const freshData = await refreshAccountInitialData();
        if (freshData?.estado) {
          setUserInitialData(freshData);
          queryClient.invalidateQueries('useGetCurrentTeamF11');
        }
      }
    },
  });
};

export default useCheckPublicacion;
